import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import {
    TOOLBAR_SLIDESIZE_CUSTOM,
    TOOLBAR_SLIDESIZE_STANDARD,
    TOOLBAR_SLIDESIZE_WIDE,
} from '@editor/src/img/pageIndex';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import {
    TDWActionType, TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import CUSTOM_ICON from '@tencent/docs-design-resources/icon/desktop/svg/pageadjust_light_24.svg';
import SLIDE_SIZE_ICON from '@tencent/docs-design-resources/icon/desktop/svg/proportion_outline_light_24.svg';

export const TWD_SLIDE_WIDE_WIDTH = '16:9';
export const TWD_SLIDE_STANDARD_WIDTH = '4:3';

export const config =  {
    id: ActionType.SLIDE_SIZE,
    content: i18n.t('幻灯片比例'),
    icon: TOOLBAR_SLIDESIZE_CUSTOM,
    twdConfig: {
        handleFunction: (value) => {
            const ver5 = value === ActionType.SLIDE_STANDARD ? TWD_SLIDE_STANDARD_WIDTH : TWD_SLIDE_WIDE_WIDTH;
            return {
                action: TDWActionType.SLIDE_SIZE,
                ver5,
            };
        },
    },
};

export const config43 =  {
    id: ActionType.SLIDE_STANDARD,
    icon: TOOLBAR_SLIDESIZE_STANDARD,
    content: i18n.t('标准（4：3）'),
};

export const config169 =  {
    id: ActionType.SLIDE_WIDE,
    icon: TOOLBAR_SLIDESIZE_WIDE,
    content: i18n.t('宽屏（16：9）'),
};

export const configCustom =  {
    id: ActionType.SLIDE_CUSTOM,
    content: i18n.t('自定义比例'),
};

export const toolbarConfig = {
    id: ActionType.SLIDE_SIZE_TOOLBAR,
    content: config.content,
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: config43.id,
        content: config43.content,
        tooltip: config43.content,
        icon: <img src={config43.icon} alt={''}/>,
    },
    {
        name: config169.id,
        content: config169.content,
        tooltip: config169.content,
        icon: <img src={config169.icon} alt={''}/>,
    },
    {
        name: MenuKey.SLIDE_SIZE,
        content: i18n.t<string>('页面设置'),
    },
    {
        name: MenuKey.SLIDE_STANDARD,
        content: config43.content,
        tooltip: config43.content,
    },
    {
        name: MenuKey.SLIDE_WIDE,
        content: config169.content,
        tooltip: config169.content,
    },
    {
        name: configCustom.id,
        content: configCustom.content,
        tooltip: configCustom.content,
        icon: <img src={CUSTOM_ICON} alt={''}/>,
    },
    {
        name: toolbarConfig.id,
        content: '',
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: toolbarConfig.id,
        style: {
            width: 'auto',
        },
        icon: <img src={SLIDE_SIZE_ICON} />,
        text: toolbarConfig.content,
        tooltip: toolbarConfig.content,
    },
];

